<div class="analysis-container">
  <div class="row">
    <div class="col-sm-4">
      <h2>{{name}}</h2>
      @if (embeddedMode) {
        <p class="company-name-label">Analysis for: <span appFsMask>{{companyName}}</span></p>
      }
    </div>
    <div class="action-button-container col-sm-4">
      @if (!embeddedMode) {
        <button (click)="downloadExcel()" class="btn btn-empty-light bottom-margin" title="Download as Excel"><i class="fas fa-file-excel"></i> Download Excel </button>
      }
      @if (!embeddedMode) {
        <button [disabled]="!company" (click)="openPdfDownloadModal()" class="btn btn-empty-light bottom-margin" title="Download as PDF"><i class="far fa-file-pdf"></i> Download PDF </button>
      }
      @if (getCompanyId()) {
        <button (click)="openSingleEntityAnalysisChangeHistory()" class="btn btn-empty-light bottom-margin change-log-button" title="Change Log"><i class="fa fa-book"></i> Change Log </button>
      }
    </div>
    <div class="col-sm-2 offset-sm-2">
      @if (showSaveButton()) {
        <button (click)="saveChanges()" class="btn btn-primary bottom-margin save-button" [disabled]="isSaveButtonDisabled">Save Changes</button>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="row top-margin">
        <div class="col-lg-4">
          <div>
            @for (proposedDebt of proposedDebts; track proposedDebt; let i = $index) {
              <app-proposed-debt-tile
                [company]="company"
                [proposedDebtId]="i"
                [(name)]="proposedDebt.name"
                [(principal)]="proposedDebt.principal"
                [(interestRate)]="proposedDebt.interestRate"
                [(termMonths)]="proposedDebt.termMonths"
                [(amortizationMethod)]="proposedDebt.amortizationMethod"
                (onRemoveProposedDebt)="removeProposedDebt($event)"
                (numericalValuesChanged)="recalculate()"
                >
              </app-proposed-debt-tile>
            }
          </div>
          <div class="row">
            <div class="col-sm-8">
              <a href="javascript:void(0)" (click)="addLoan()">Add Proposed Loan</a>
            </div>
          </div>
          <div>
            <app-loan-commentary-tile
              [commentary]="commentary"
              (commentaryChange)="changeCommentary($event)"
              >
            </app-loan-commentary-tile>
          </div>
        </div>
        <div class="col-lg-8 table-container">
          <app-debt-service-coverage-table
            [templateItems]="templateItems"
            [columns]="columns"
            [scopes]="scopes"
            [proposedDebts]="proposedDebts"
            [dataOverrides]="dataOverrides"
            [allowCellEditing]="allowCellEditing"
            [refToOverrideIdx]="refToOverrideIdx"
            [templateHasSections]="templateHasSections"
            [projectionScenarioTypeLabelOverride]="projectionScenarioTypeLabelOverride"
            (doneEditing)="manuallyEditedValue($event)"
            >
          </app-debt-service-coverage-table>
        </div>
      </div>
    </div>
  </div>
</div>
